<template>
  <div class="payPage">
    <div class="pay">
      <el-row class="centerIE">
        <el-col :span="4"><i class="el-icon-circle-check"></i></el-col>
      </el-row>
      <el-row>
        <el-col
          ><p>已成功为您安排考场,可点击按钮查看准考证！<el-button type="success" @click="toReportHandle">点击查看</el-button></p></el-col
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
	  ...mapState({
			// ...mapState(['recId'])
	    stepIndex: 'stepIndex',
	    print_url: 'print_url'
	  })
  },
  methods: {
    toReportHandle() {
		
		var print_url = window.sessionStorage.getItem('print_url')
		window.location.href = print_url
   //    let id = this.$route.singupid
   //    console.log(id)
	  // console.log(this.recId)
      // this.$router.push({
      //   path: '/Print',
      //   query: { singupid: this.recId}
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.payPage {
  .pay {
    color: #67c23a;
    i {
      font-size: 80px;
      margin-top: 50px;
      margin-bottom: 18px;
    }
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 28px;
      line-height: 50px;
    }
    .el-button {
      margin-left: 20px;
    }
  }
  @include autoInner;
}
// icon居中
.centerIE {
  transform: translate(45%);
}
</style>
